<template>
    <div>
        <el-dialog title="代理人信息设置" style="text-align:center" :visible="visible" :show="show" width="60%"  @close="close" :close-on-click-modal="false">
            <h3 style="text-align:center">{{rowData.orgName}}代理人分配
                <el-button type="success" style="margin-left:20%" @click="searchUserList()">用户查找<i class="el-icon-search"/></el-button>
            </h3>
            <el-table :data="dataList"  border  style="width: 100%" height="500px">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="fullName" label="姓名"  align="center"></el-table-column>
                <el-table-column prop="account" label="账号" align="center" width="100"></el-table-column>
                <el-table-column prop="isBroken" label="是否锁定" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.islock=='1'">正常</span>
                        <span v-if="scope.row.islock=='0'">锁定</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
                <el-table-column label="到场地选择" align="center" width="400">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.zdOrgIdArr" multiple style="width:100%">
                            <el-option v-for="(item,i) in zdOrgList" :label="item.orgName" :value="item.orgId+''"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger" icon="el-icon-delete"  size="mini"  @click="deleteHandler(scope.$index)">删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="this.dataList.length>0" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="用户信息" style="text-align:center" :visible="userVisible" width="40%"  >
            <el-form :inline="true" :model="searchForm" class="form-content" ref="userDataTable">
                <el-row :gutter="20" class="slt">
                    <el-form-item label="姓名">
                        <el-input prefix-icon="el-icon-search" v-model="searchForm.fullName" placeholder="姓名"  clearable></el-input>
                    </el-form-item>
                    <el-form-item label="账号">
                        <el-input prefix-icon="el-icon-search" v-model="searchForm.account" placeholder="账号"   clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="search">查询<i class="el-icon-search"/></el-button>
                        <el-button class="btn" type="primary"  @click="commitUser()">确定</el-button>
                        <el-button class="btn" type="primary"  @click="addUser()">添加用户</el-button>
                        <el-button class="btn" type="primary"  @click="userVisible = false">取消</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <el-table :data="userDataList"  border  style="width: 100%" height="500px" @selection-change="selectionChangeHandler" ref="userDataTable" >
                <el-table-column  type="selection"
                                  header-align="center"
                                  align="center"
                                  width="50">
                </el-table-column>
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="fullName" label="姓名"  align="center"></el-table-column>
                <el-table-column prop="account" label="账号" align="center" ></el-table-column>
                <el-table-column prop="islock" label="是否锁定" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.islock=='1'">正常</span>
                        <span v-if="scope.row.islock=='0'">锁定</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
            </el-table>
        </el-dialog>
        <user-dialog :show="userShow"  v-on:listenToChildEvent="closeUserDialog"></user-dialog>
    </div>
</template>
<script>
    import UserDialog  from '../users/add-or-update.vue'
    export default{
        name:'orgUserList',
        components: {
            UserDialog
        },
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initUserList();
                }
            },
            rowData(){
                if (this.show){
                    this.getUserListByOrgId();
                    this.getZdOrgList();
                }
            },
        },
        data(){
            return{
                userShow:false,
                visible:false,
                dataList:[],
                userDataList:[],
                userVisible:false,
                dataListSelections:[],
                searchForm:{
                    fullName:'',
                    account:'',
                },
                zdOrgList:[],
            }
        },
        methods:{
            close(){
                this.dataList = [];
                this.dataListSelections = [];
                this.$emit("listenToChildEvent",false);
            },
            searchUserList(){
                this.userVisible = true;
                this.searchForm.fullName = '';
                this.searchForm.account = '';

            },
            search(){
                this.initUserList();
            },
            initUserList(){
                let params = {'userType':this.rowData.userType};
                if(this.searchForm.fullName!='' && this.searchForm.fullName!=undefined){
                    params['fullName'] = this.searchForm.fullName
                }
                if(this.searchForm.account!='' && this.searchForm.account!=undefined){
                    params['account'] = this.searchForm.account
                }
                this.$http({
                    url: "users/list",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.userDataList = data.data;
                    }
                });
            },
            //确定已选择用户
            commitUser(){
                //this.dataList = this.dataListSelections;
                this.userVisible = false;
                this.dataListSelections.map(item=>{
                    if(!this.containsObject(this.dataList,item)){
                        let zdOrgIdArr = [];
                        this.zdOrgList.map(item=>zdOrgIdArr.push(item.orgId+''));
                        item.zdOrgIdArr = zdOrgIdArr;
                        this.dataList.push(item);
                    }
                })
            },
            containsObject(arr, obj) {
                return arr.some(element=> {
                    return element.id === obj.id; // 假设对象有一个名为'id'的属性
                });
            },

            // 多选
            selectionChangeHandler(val) {
                this.dataListSelections = val;
            },
            deleteHandler(index){
                this.dataList.splice(index,1);
            },
            commit(){
                let arr = [];
                let type = this.rowData.userType;
                this.dataList.map(item=>{
                    let zdOrgIds = item.zdOrgIdArr.join(",");
                    let obj = {orgId:this.rowData.orgId,userId:item.id,zdOrgIds:zdOrgIds,type:type};
                    arr.push(obj);
                })
                this.$http({
                    url: `sysUserOrg/save`,
                    method: "post",
                    data: arr
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.close();
                            }
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
            getUserListByOrgId(){
                let params = {'searchType':'1'};
                this.$http({
                    url: `sysUserOrg/getUserListByOrgId/`+this.rowData.orgId,
                    method: "get",
                    params:params
                }).then(({ data }) => {
                    //this.dataList = data.userList;
                    let arr = data.userList;
                    this.dataList = [];
                    arr.map(item=>{
                        if (item.zdOrgIds!=null){
                            item.zdOrgIdArr = item.zdOrgIds.split(",");
                        }
                        this.dataList.push(item);
                    })
                });
            },
            getZdOrgList(){
                if (this.rowData.userType=='2'){
                    let params = {"t.orgSupId":this.rowData.orgId};
                    this.$http({
                        url: "sysOrg/list",
                        method: "get",
                        params: params
                    }).then(({ data }) => {
                        if (data && data.code === 0) {
                            this.zdOrgList = data.data;
                        }
                    });
                }else{
                    let arr = [];
                    arr.push(this.rowData);
                    this.zdOrgList = arr;
                }
            },
            addUser(){
                this.userShow = true;
            },
            closeUserDialog(){
                this.userShow = false;
            }
        }
    }
</script>